import React from "react";
import { useI18n } from "../../i18n";
import { Container } from "../../components/ui/Primitives";
import { Button } from "../../components/ui/Button";
import { Logo } from "../../components/ui/Logo";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-950 text-white">
      <div className="absolute inset-0 cyber-grid opacity-60" />
      <Container className="relative text-center">
        <Logo forceDark />
        <p className="mt-10 font-mono text-7xl font-black text-brand">404</p>
        <h1 className="mt-4 text-2xl text-white">{t("nf.title")}</h1>
        <p className="mt-2 text-white/60">{t("nf.body")}</p>
        <Button to="/" className="mt-8">
          {t("common.backHome")}
        </Button>
      </Container>
    </div>
  );
}
